/* Create a link to skip to the chat widget. Fix missing focus styling in chat widget button */
const chatWidgetContainerObserver = new MutationObserver((mutations) => {
	for (const { addedNodes } of mutations) {
		for (const node of addedNodes) {
			if (node instanceof HTMLIFrameElement) {
				addFocusStylesIframe(node);
				node.onload = () => addFocusStylesIframe(node);
			}
		}
	}
});

const bodyObserver = new MutationObserver((mutations, observer) => {
	for (const { addedNodes } of mutations) {
		for (const node of addedNodes) {
			if (
				node instanceof HTMLElement &&
				(node.classList.contains("widget-hidden") ||
					node.classList.contains("widget-visible"))
			) {
				observer.disconnect();
				node.id ||= "chat-widget-container";
				const anchor = document.createElement("a");
				anchor.href = "#" + node.id;
				anchor.className = "visuallyhidden focusable skip-link";
				anchor.textContent = "Skip to chat";
				document.body.prepend(anchor);
				for (const iframe of node.querySelectorAll("iframe")) {
					// add focus styles if iframes already exist
					addFocusStylesIframe(iframe);
				}
				chatWidgetContainerObserver.observe(node, {
					childList: true,
				});
			}
		}
	}
});

bodyObserver.observe(document.body, {
	childList: true,
});

/** @param {HTMLIFrameElement} iframe */
function addFocusStylesIframe(iframe) {
	const style = document.createElement("style");
	style.id = "chat-button-fucus-styles";
	style.textContent = `
    :focus-visible {
      outline: 1px auto !important;
    }
  `;
	iframe.contentDocument.head.append(style);
}
